import React, { useRef, useState, useEffect } from "react";
import SignatureCanvas from "react-signature-canvas";
import { Link, useNavigate } from "react-router-dom";
import Header from "./../component/Header";
import Sidebar from "./../component/Sidebar"; // Corrected the component name here

const EditIcon = require("./../assets/img/edit-icon.svg").default;
const viewIcon = require("./../assets/img/eye-icon.svg").default;
const searchIcon = require("./../assets/img/search-icon.svg").default;
const CrossBtn = require("./../assets/img/cross-icon.svg").default;
const logo = require("./../assets/img/logo.svg").default;
const demoImg = require("./../assets/img/demo-img.png");
const companyLogo = require("./../assets/img/company-logo.svg").default;
const removeIcon = require("./../assets/img/remove-icon.svg").default;
const downloadIcon = require("./../assets/img/download-icon.svg").default;
const HistoryIcon = require("./../assets/img/history-icon.svg").default;

const ViewFiles = () => {
  const navigate = useNavigate();
  const [showPreviewPopup, setShowPreviewPopup] = useState(false);
  const [showPreviewPopup2, setShowPreviewPopup2] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [fileData, setFileData] = useState([]);
  const [userData, setUserData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedFiles, setSelectedFiles] = useState([]); // Add this line
  const [showPopup, setShowPopup] = useState(false); // Add this line
  const filesPerPage = 20; // Number of files to display per page
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [fileToRemove, setFileToRemove] = useState(null);
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [searchKey, setSearchKey] = useState("");
  const [pageNumber, setPageNumber] = useState("1");
  const [pageLimit, setPageLimit] = useState("20");
  const [totalRecord, setTotalRecord] = useState(0);
  const [timer, setTimer] = useState(null);
  const [jobNumber, setJobNumber] = useState();
  const [storeName, setStoreName] = useState();
  const [status, setStatus] = useState();

  const handleCheckboxChange = (event, fileName) => {
    const checked = event.target.checked;
    if (checked) {
      setSelectedFiles((prevSelectedFiles) => [...prevSelectedFiles, fileName]);
    } else {
      setSelectedFiles((prevSelectedFiles) =>
        prevSelectedFiles.filter((file) => file !== fileName)
      );
    }
  };

  const delayExecution = (callback, ms) => {
    clearTimeout(timer);
    const newTimer = setTimeout(callback, ms);
    setTimer(newTimer);
  };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    setPageNumber(pageNumber);
    formDataSubmit(pageNumber, searchKey);
  };

  const handleSearchChange = (event) => {
    setSearchKey(event.target.value);

    delayExecution(() => {
      formDataSubmit(pageNumber, event.target.value);
    }, 500);
  };

  const handleFilterButtonClick = () => {
    setShowPopup((prevShowPopup) => !prevShowPopup);
  };

  const handlePreviewBtnClick = () => {
    setShowPreviewPopup(true);
  };
  const popupBtnClick = () => {
    setShowPreviewPopup(false);
  };

  const handlePreviewBtnClick2 = (formKey) => {
    navigate(`/view-one-form/${formKey}`);
    // setShowPreviewPopup2(true);
  };
  const popupBtnClick2 = () => {
    setShowPreviewPopup2(false);
  };

  const signatureRef = useRef();
  const [canvasSize, setCanvasSize] = useState({
    width: 650,
    height: 200,
  });

  const handleClear = () => {
    signatureRef.current.clear();
  };

  const handleSave = () => {
    const signatureData = signatureRef.current.toDataURL();
    // You can now save or use the signatureData as needed.
  };

  const fetchAllFiles = (storedUserData) => {
    formDataSubmit(pageNumber, searchKey);
  };

  const formDataSubmit = (pageNumber, searchKey) => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));

    // Construct the URL with from_date and to_date parameters
    const form = new FormData();
    form.append("from_date", fromDate);
    form.append("to_date", toDate);
    form.append("search_key", searchKey);
    form.append("page_no", pageNumber);
    form.append("limit", pageLimit);
    form.append("job_code", jobNumber ? jobNumber : "");
    form.append("store_name", storeName ? storeName : "");
    form.append("status", status ? status : "");

    fetch(`https://cliqestimatebuilder.com/waiver_admin/forms/all/`, {
      headers: {
        Authorization: `Bearer ${storedUserData.token}`,
      },
      method: "POST",
      body: form,
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data && Array.isArray(data.data)) {
          setFileData(data.data);

          // Check if totalRecord exists in the data object
          if ("totalRecord" in data) {
            setTotalRecord(data.totalRecord);
          } else {
            setTotalRecord(0); // Set totalRecord to 0 if it's not present in response
          }
        } else {
          setFileData([]);
          setTotalRecord(0);
          console.error("Received data is not in the expected format:", data);
        }
      })
      .catch((error) => console.error("Error fetching file data:", error));
  };

  const handlePopupSubmit = (event) => {
    event.preventDefault();
    setShowPopup(false); // Close the popup
    setCurrentPage(1); // Reset to the first page
    setShowPreviewPopup(false);

    formDataSubmit(pageNumber, searchKey);
  };

  const handleSearchSubmit = (event) => {
    event.preventDefault();
    setCurrentPage(1); // Reset to the first page
    formDataSubmit(pageNumber, searchKey);
  };

  const showPagination = Math.ceil(totalRecord / filesPerPage);

  const totalPages = Math.ceil(totalRecord / filesPerPage); // Calculate total pages

  const handleRemoveClick = (index, fileId) => {
    setFileToRemove({ index, fileId });
    setShowConfirmationModal(true);
  };

  const deleteFile = () => {
    if (fileToRemove) {
      const { index, fileId } = fileToRemove;
      const storedUserData = JSON.parse(localStorage.getItem("userData"));
      fetch(
        `https://cliqestimatebuilder.com/waiver_admin/forms/trash/${fileId}`,
        {
          method: "PUT",
          headers: {
            Authorization: `Bearer ${storedUserData.token}`,
          },
        }
      )
        .then((response) => response.json())
        .then((data) => {
          console.log(data);
          if (data.res == 1) {
            // Update the file list by removing the file at the specified index
            fetchAllFiles(storedUserData);
          } else {
            if (data.error) {
              console.error("Error deleting file:", data.error);
              // Handle the error condition if required
            } else {
              console.error("Error deleting file: Unknown error");
              // Handle other types of errors
            }
          }
        })
        .catch((error) =>
          console.error("Error changing delete status:", error)
        );

      setShowConfirmationModal(false);
      setFileToRemove(null);
    }
  };

  useEffect(() => {
    const handleResize = () => {
      const newCanvasSize = {
        width: window.innerWidth >= 768 ? 650 : "250",
        height: window.innerWidth >= 768 ? 200 : "130",
      };
      setCanvasSize(newCanvasSize);
    };

    window.addEventListener("resize", handleResize);
    handleResize(); // Initialize canvas size based on initial window width

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    const storedUserData = JSON.parse(localStorage.getItem("userData"));
    setUserData(storedUserData);

    fetchAllFiles(storedUserData);
  }, []);

  return (
    <div className="bodyMain">
      <div className="sideBar">
        <Sidebar />
      </div>

      <div className="contentDiv">
        <Header userData={userData} />

        <div className="mainContent">
          <div className="viewBox">
            <div className="topSearch">
              <div className="searchSec">
                <h2>All Forms</h2>

                <div className="rgtSearch">
                  <form onSubmit={handleSearchSubmit}>
                    <input
                      type="search"
                      placeholder="Search here"
                      value={searchKey}
                      onChange={(e) => handleSearchChange(e)}
                    />
                    <button type="submit">
                      <img src={searchIcon} alt="" />
                    </button>
                  </form>
                  <button
                    className="filterBtn"
                    onClick={handlePreviewBtnClick}
                  ></button>

                  {showPreviewPopup && (
                    <div className="filterSidebar">
                      <div className="filterInner">
                        <div className="fliterHdn">
                          <h3>Filter</h3>

                          <button
                            className="popupCloseBtn"
                            onClick={() => popupBtnClick()}
                          >
                            <img src={CrossBtn} alt="Remove" />
                          </button>
                        </div>

                        <div className="fliterForm">
                          <form
                            onSubmit={handlePopupSubmit}
                            className="viewForms"
                          >
                            <ul>
                              <li>
                                <label>Filter by Job number</label>
                                <input
                                  type="text"
                                  value={jobNumber}
                                  onChange={(e) => setJobNumber(e.target.value)}
                                />
                              </li>
                              <li>
                                <label>Filter by Store name</label>
                                <input
                                  type="text"
                                  value={storeName}
                                  onChange={(e) => setStoreName(e.target.value)}
                                />
                              </li>
                              <li className="frmDte">
                                <label htmlFor="fromDate" className="fltrDate">
                                  Filter by Created date
                                </label>

                                <label htmlFor="toDate">From Date:</label>
                                <input
                                  type="date"
                                  id="fromDate"
                                  value={fromDate}
                                  onChange={(e) => setFromDate(e.target.value)}
                                />
                              </li>
                              <li>
                                <label htmlFor="toDate">To Date:</label>
                                <input
                                  type="date"
                                  id="toDate"
                                  value={toDate}
                                  onChange={(e) => setToDate(e.target.value)}
                                />
                              </li>
                              <li>
                                <label>Filter by Status</label>
                                <select
                                  value={status}
                                  onChange={(e) => setStatus(e.target.value)}
                                >
                                  <option value={0}>Created</option>
                                  <option value={1}>Signed</option>
                                  <option value={2}>Cancelled</option>
                                </select>
                              </li>
                              <li>
                                <button type="submit">Submit</button>
                              </li>
                            </ul>
                          </form>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="viewFileList">
              <h3>Total {totalRecord} Forms</h3>
              <div className="listing vewFrmTable crteFmrList vwFrmWid">
                <table>
                  <thead>
                    <tr>
                      <th></th>
                      <th>Name</th>
                      {Number(userData?.role_id) === 1 ? (
                        <th>Created by</th>
                      ) : null}
                      <th>Create On</th>
                      <th>Signed Date</th>
                      <th>Status</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  {fileData?.length > 0 ? (
                    <tbody>
                      {fileData.map((file, index) => (
                        <tr
                          key={index}
                          className={
                            selectedFiles.includes(file.id) ? "active" : ""
                          }
                        >
                          <td className="checkWidth">
                            <input
                              type="checkbox"
                              checked={selectedFiles.includes(file.id)}
                              onChange={(event) =>
                                handleCheckboxChange(event, file.id)
                              }
                            />
                          </td>
                          {/* <td className="countWidth">{index + 1}</td> */}
                          <td className="formName frmWid">{file.job_name}</td>
                          {Number(userData?.role_id) === 1 ? (
                            <td>{file.created_by}</td>
                          ) : null}
                          <td className="crteWid">{file.created_at}</td>
                          <td className="crteWid">{file.signed_date}</td>
                          <td
                            className={
                              Number(file.status) === 0
                                ? "status"
                                : Number(file.status) === 1
                                ? "signedBtn"
                                : Number(file.status) === 2
                                ? "status cancelledBtn"
                                : null
                            }
                          >
                            {Number(file.status) === 0
                              ? "Created"
                              : Number(file.status) === 1
                              ? "Signed"
                              : Number(file.status) === 2
                              ? "Cancelled"
                              : null}
                          </td>

                          <td className="btnsWidth">
                            {Number(file.status) === 0 ? (
                              <>
                                {file?.email == null ? (
                                  <Link
                                    to={`/edit-form/${file?.form_key}`}
                                    className="createBtn assignBtn asignNew"
                                  >
                                    Assign
                                  </Link>
                                ) : (
                                  <Link
                                    to={`/edit-form/${file?.form_key}`}
                                    className="createBtn assignBtn asignNew"
                                  >
                                    Reassign
                                  </Link>
                                )}
                                <button
                                  onClick={() =>
                                    handlePreviewBtnClick2(file?.form_key)
                                  }
                                >
                                  <img src={viewIcon} alt="View" />
                                </button>
                                <button>
                                  <Link to={`/edit-form/${file?.form_key}`}>
                                    <img src={EditIcon} alt="" />
                                  </Link>
                                </button>
                                <button>
                                  <Link to={`/history/${file?.form_key}`}>
                                    <img
                                      src={HistoryIcon}
                                      alt=""
                                      className="hstryIcon"
                                    />
                                  </Link>
                                </button>
                              </>
                            ) : Number(file.status) === 1 ? (
                              <>
                                <button
                                  onClick={() =>
                                    handlePreviewBtnClick2(file?.form_key)
                                  }
                                >
                                  <img src={viewIcon} alt="View" />
                                </button>
                                <button>
                                  <Link to={`/history/${file?.form_key}`}>
                                    <img
                                      src={HistoryIcon}
                                      alt=""
                                      className="hstryIcon"
                                    />
                                  </Link>
                                </button>
                                <button>
                                  <Link
                                    to={
                                      "https://cliqestimatebuilder.com/waiver_admin/" +
                                      file?.pdf
                                    }
                                    target="_blank"
                                  >
                                    <img src={downloadIcon} alt="View" />
                                  </Link>
                                </button>
                              </>
                            ) : Number(file.status) === 2 ? (
                              <>
                                <Link
                                  to={`/edit-form/${file?.form_key}`}
                                  className="createBtn assignBtn"
                                >
                                  Reassign
                                </Link>
                                <button
                                  onClick={() =>
                                    handlePreviewBtnClick2(file?.form_key)
                                  }
                                >
                                  <img src={viewIcon} alt="View" />
                                </button>
                                <button>
                                  <Link to={`/edit-form/${file?.form_key}`}>
                                    <img src={EditIcon} alt="" />
                                  </Link>
                                </button>
                                <button>
                                  <Link to={`/history/${file?.form_key}`}>
                                    <img
                                      src={HistoryIcon}
                                      alt=""
                                      className="hstryIcon"
                                    />
                                  </Link>
                                </button>
                              </>
                            ) : null}
                            {selectedFiles.includes(file.id) ? (
                              <Link
                                to=""
                                onClick={() =>
                                  handleRemoveClick(index, file.id)
                                }
                                className="mveTrsh"
                              >
                                <img src={removeIcon} alt="" />
                              </Link>
                            ) : null}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  ) : (
                    <tr>
                      <td colSpan={6} className="clsPan">
                        <span class="lgnStatus">Forms Not Found</span>
                      </td>
                    </tr>
                  )}
                  {showConfirmationModal ? (
                    <div className="confirmation-modal">
                      <div className="modal-content">
                        <p>Are you sure you want to remove this file?</p>
                        <div className="modal-buttons">
                          <button onClick={() => deleteFile()}>Yes</button>
                          <button
                            onClick={() => setShowConfirmationModal(false)}
                          >
                            Cancel
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : null}
                  {/* <tr className={selectedFiles.includes("Form-1") ? "active" : ""}>
                      <td className="checkWidth">
                        <input type="checkbox" onChange={event => handleCheckboxChange(event, "Form-1")} />
                      </td>
                      <td className="formName">Form-1</td>
                      <td>05 July, 2023</td>
                      <td>17 July, 2023</td>
                      <td className="status">Created</td>
                      <td className="btnsWidth">
                        <Link to="" className="createBtn assignBtn">
                          Assign
                        </Link>
                        <button onClick={handlePreviewBtnClick2}>
                          <img src={viewIcon} alt="View" />
                        </button>
                        <button>
                          <Link to="">
                            <img src={EditIcon} alt="" />
                          </Link>
                        </button>
                      </td>
                    </tr>
                    <tr className={selectedFiles.includes("Form-1") ? "active" : ""}>
                      <td className="checkWidth">
                        <input type="checkbox" onChange={event => handleCheckboxChange(event, "Form-1")} />
                      </td>
                      <td className="formName">Form-2</td>
                      <td>05 July, 2023</td>
                      <td>17 July, 2023</td>
                      <td className="signedBtn">Signed</td>
                      <td className="btnsWidth">
                        <Link to="" className="createBtn trashBtn">
                          Move To Trash
                        </Link>
                        <button onClick={handlePreviewBtnClick2}>
                          <img src={viewIcon} alt="View" />
                        </button>
                      </td>
                    </tr>
                    <tr className={selectedFiles.includes("Form-1") ? "active" : ""}>
                      <td className="checkWidth">
                        <input type="checkbox" onChange={event => handleCheckboxChange(event, "Form-1")} />
                      </td>
                      <td className="formName">Form-3</td>
                      <td>05 July, 2023</td>
                      <td>17 July, 2023</td>
                      <td className="status cancelledBtn">Cancelled</td>
                      <td className="btnsWidth">
                        <Link to="" className="createBtn assignBtn">
                          Reassign
                        </Link>
                        <button onClick={handlePreviewBtnClick2}>
                          <img src={viewIcon} alt="View" />
                        </button>
                        <button>
                          <Link to="">
                            <img src={EditIcon} alt="" />
                          </Link>
                        </button>
                      </td>
                    </tr>
                    <tr className={selectedFiles.includes("Form-1") ? "active" : ""}>
                      <td className="checkWidth">
                        <input type="checkbox" onChange={event => handleCheckboxChange(event, "Form-1")} />
                      </td>
                      <td className="formName">Form-4</td>
                      <td>05 July, 2023</td>
                      <td>17 July, 2023</td>
                      <td className="signedBtn">Signed</td>
                      <td className="btnsWidth">
                        <button onClick={handlePreviewBtnClick2}>
                          <img src={viewIcon} alt="View" />
                        </button>
                      </td>
                    </tr>
                    <tr className={selectedFiles.includes("Form-1") ? "active" : ""}>
                      <td className="checkWidth">
                        <input type="checkbox" onChange={event => handleCheckboxChange(event, "Form-1")} />
                      </td>
                      <td className="formName">Form-5</td>
                      <td>05 July, 2023</td>
                      <td>17 July, 2023</td>
                      <td className="status cancelledBtn">Cancelled</td>
                      <td className="btnsWidth">
                        <Link to="" className="createBtn assignBtn">
                          Reassign
                        </Link>
                        <button onClick={handlePreviewBtnClick2}>
                          <img src={viewIcon} alt="View" />
                        </button>
                        <button>
                          <Link to="">
                            <img src={EditIcon} alt="View" />
                          </Link>
                        </button>
                      </td>
                    </tr> */}
                </table>
              </div>
            </div>

            {showPagination ? (
              <div className="paginationDiv">
                <ul>
                  {Array.from({ length: totalPages }, (_, index) => (
                    <li key={index}>
                      <Link
                        to="#"
                        className={currentPage === index + 1 ? "active" : ""}
                        onClick={() => handlePageChange(index + 1)}
                      >
                        {index + 1}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ) : null}
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewFiles;
